var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C14.3734 2.83022e-08 16.6935 0.703788 18.6668 2.02236C20.6402 3.34094 22.1783 5.21509 23.0866 7.4078C23.9948 9.60051 24.2324 12.0133 23.7694 14.3411C23.3064 16.6689 22.1635 18.8071 20.4853 20.4853C18.8071 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0866C5.21509 22.1783 3.34094 20.6402 2.02236 18.6668C0.703788 16.6935 -5.66044e-08 14.3734 0 12H2.4C2.4 13.8987 2.96303 15.7548 4.01789 17.3335C5.07275 18.9122 6.57207 20.1426 8.32624 20.8692C10.0804 21.5958 12.0106 21.786 13.8729 21.4155C15.7351 21.0451 17.4456 20.1308 18.7882 18.7882C20.1308 17.4456 21.0451 15.7351 21.4155 13.8729C21.786 12.0106 21.5958 10.0804 20.8692 8.32624C20.1426 6.57207 18.9122 5.07275 17.3335 4.01789C15.7548 2.96303 13.8987 2.4 12 2.4V0Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiEllipse);
export default __webpack_public_path__ + "static/media/semi-ellipse.45aa3a9070589549c4caf5a468920076.svg";
export { ForwardRef as ReactComponent };